<script setup>
import lottie from "lottie-web/build/player/lottie_light";
import { useSharedIntersectionObserver } from "@/composables/useSharedIntersectionObserver";

const lottieRef = ref(null);
let lottieAnimation = null;

const props = defineProps({
    animationData: {
        type: Object,
        required: true,
    },
    loop: {
        type: Boolean,
        default: true,
    },
    autoplay: {
        type: Boolean,
        default: true,
    },
    speed: {
        type: Number,
        default: 1,
    },
    // 是否啟用可見性控制（不可見時暫停動畫）
    pauseOnHidden: {
        type: Boolean,
        default: true,
    },
});

// 使用共享 Observer（可見性控制用）
const { observe, unobserve } = useSharedIntersectionObserver({
    threshold: 0.1,
});

onMounted(() => {
    lottieAnimation = lottie.loadAnimation({
        container: lottieRef.value,
        renderer: "svg",
        loop: props.loop,
        autoplay: props.autoplay,
        animationData: props.animationData,
        rendererSettings: {
            progressiveLoad: true,
            preserveAspectRatio: "xMidYMid slice",
        },
    });
    lottieAnimation.setSpeed(props.speed);
    lottieAnimation.setSubframe(true);

    // 使用共享 Intersection Observer 控制動畫播放
    if (props.pauseOnHidden && lottieRef.value) {
        observe(lottieRef.value, (entry) => {
            if (lottieAnimation) {
                entry.isIntersecting ? lottieAnimation.play() : lottieAnimation.pause();
            }
        });
    }
});

onBeforeUnmount(() => {
    // 清理共享 Observer 的註冊
    unobserve(lottieRef.value);
    if (lottieAnimation) {
        lottieAnimation.destroy();
    }
});

// 暴露控制方法
defineExpose({
    play: () => lottieAnimation?.play(),
    pause: () => lottieAnimation?.pause(),
    stop: () => lottieAnimation?.stop(),
    goToAndPlay: (frame) => lottieAnimation?.goToAndPlay(frame),
    goToAndStop: (frame) => lottieAnimation?.goToAndStop(frame, true),
});
</script>

<template>
    <div ref="lottieRef"></div>
</template>
